import * as React from "react";
import styled, { css } from "styled-components";

import { Caret } from "@ui/Assets/Symbolicons/Caret";
import theme from "@ui/themes/default";
import { transition } from "@ui/helpers";
import { Margins } from "@ui/Atoms";

import { useTranslate } from "@hooks/useTranslate";
import { useLocalisation } from "@hooks/useLocalisation";

import { Modal } from "@app/containers/Modal";
import { useModalStore } from "@app/hooks/useModalStore";

import { WarrantyModalContent } from "../EndOfTenancyProcess/sections/WarrantyModalContent";
import { WhatIsIncluded } from "../EndOfTenancyProcess/sections/WhatIsIncluded";

import { END_OF_TENANCY_MODALS_ENUM } from "./EndOfTenancy.modals.types";

const WarrantyModal = (): React.ReactElement => {
  const translate = useTranslate("batmaid_pwa_end_of_tenancy");
  const { hideModal } = useModalStore();
  const { country, language } = useLocalisation();

  const [showWhatIsIncluded, toggleShowWhatIsIncluded] =
    React.useState<boolean>(false);

  return (
    <Modal
      title={translate("modal_warranty_title")}
      id={END_OF_TENANCY_MODALS_ENUM.WARRANTY}
      submit={() => {
        hideModal(END_OF_TENANCY_MODALS_ENUM.WARRANTY);
      }}
      withCancelBtn={false}
      submitBtnColor={"blue"}
      submitText={translate("modal_warranty_btn_text")}
      withContainedHeight
    >
      <Margins xs={["base", "base_x2", null, null]}>
        <React.Fragment>
          <Margins xs={[null, "base_x6", null, null]}>
            <div>
              <WarrantyModalContent country={country} language={language} />
            </div>
          </Margins>
          <StyledLink
            href="#"
            role="button"
            onClick={e => {
              e.preventDefault();
              toggleShowWhatIsIncluded(state => !state);
            }}
          >
            <CaretWrapper showWhatIsIncluded={showWhatIsIncluded}>
              <Caret variant="solid" color={theme.palette.blue500} size={28} />
            </CaretWrapper>
            {translate("check_whats_included_in_the_cleaning")}
          </StyledLink>
          {showWhatIsIncluded && (
            <Margins xs={["base_x6", null, null, null]}>
              <div>
                <WhatIsIncluded />
              </div>
            </Margins>
          )}
        </React.Fragment>
      </Margins>
    </Modal>
  );
};

export { WarrantyModal };

WarrantyModal.displayName = "WarrantyModal";

const StyledLink = styled.a`
  display: block;
`;

const CaretWrapper = styled.span<{ showWhatIsIncluded: boolean }>`
  padding-right: ${props => props.theme.margins.half};

  svg {
    transition: ${transition("transform")};
  }

  ${({ showWhatIsIncluded }) =>
    !showWhatIsIncluded &&
    css`
      svg {
        transform: rotate(-90deg);
      }
    `}
`;
